// extracted by mini-css-extract-plugin
export default {"Box":"shared-issue-viewer-module__Box--NdBzI","Box_1":"shared-issue-viewer-module__Box_1--SqEHO"};